import {useContext} from "react"
import {AuthContext} from "../Context/ContextApi"
function Home(){
    const {auth} = useContext(AuthContext)
    return (
        <>
    <h1>Welcome</h1>
    <button onClick={()=>auth()}>Logout</button>
    </>
    )
}

export default Home